import React from 'react'

import { ZariContext } from '_zari/context'
import { Table } from '_zari/core'

import { TiposCajaChica } from 'constants/index'

import { ZrSwal } from 'utils'

import * as CajaChicaService from 'services/cajaChica.service'

const MainRow = ({ row, mostrarNuevoDocSection, mostrarNuevoSinDocSection, reloadTable }) => {
  const __zariContext = React.useContext(ZariContext)

  const clickEditar = React.useCallback(() => {
    const funcionEditar =
      row.tipo === TiposCajaChica.SIN_DOCUMENTO
        ? () => CajaChicaService.obtenerxIdAsEdicionSinDocumento(row._id)
        : () => CajaChicaService.obtenerxIdAsEdicionConDocumento(row._id)

    funcionEditar()
      .then(({ data }) => {
        if (row.tipo === TiposCajaChica.SIN_DOCUMENTO) {
          mostrarNuevoSinDocSection(data)
        } else if (row.tipo === TiposCajaChica.CON_DOCUMENTO) {
          mostrarNuevoDocSection(data)
        }
      })
      .catch(({ data: { error } }) => {
        __zariContext.snack('error', error)
      })
  }, [__zariContext, row, mostrarNuevoDocSection, mostrarNuevoSinDocSection])

  const clickEliminar = React.useCallback(() => {
    ZrSwal.showAlert({
      mensaje: 'Seguro de eliminar el registro?',
      tipo: 'error',
      showCerrar: true,
      onSuccess: () => {
        CajaChicaService.eliminarxId(row._id)
          .then(() => {
            __zariContext.toast('success', 'El registro se ha eliminado')
            reloadTable()
          })
          .catch(({ data: { error } }) => {
            __zariContext.snack('error', error)
          })
      }
    })
  }, [__zariContext, row, reloadTable])

  return (
    <Table.Row>
      <Table.Cell>{row.tipoDocumento || '--'}</Table.Cell>
      <Table.Cell>{row.serieDocumento || '--'}</Table.Cell>
      <Table.Cell>{row.numeroDocumento || '--'}</Table.Cell>
      <Table.Cell>{row.glosa || '--'}</Table.Cell>
      <Table.Cell>{row.moneda || '--'}</Table.Cell>
      <Table.Cell>{row.monto || '--'}</Table.Cell>
      <Table.Cell>
        <Table.Dropdown>
          {({ handleClose }) => [
            <Table.Dropdown.Item key='editar' handleClose={handleClose} onClick={clickEditar}>
              Editar
            </Table.Dropdown.Item>,
            <Table.Dropdown.Item key='eliminar' handleClose={handleClose} onClick={clickEliminar}>
              Eliminar
            </Table.Dropdown.Item>
          ]}
        </Table.Dropdown>
      </Table.Cell>
    </Table.Row>
  )
}

export default React.memo(MainRow)
